(function($) {

	$('input[type="text"], input[type="email"], textarea').on('focus',function(){
		$(this).closest('fieldset, .gfield').find('label').addClass('active');
	});

	$('input[type="text"], input[type="email"], textarea').on('blur',function(){
		if ($(this).val()=='') {
			$(this).closest('fieldset, .gfield').find('label').removeClass('active');
		}
	});

})( jQuery );  